import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { Link } from 'react-router-dom';
import { withIcon } from '../../core/components/Icon.tsx';
import Page from '../../core/components/Page/index.tsx';
import Tooltip from '../../core/components/Tooltip.tsx';

const BackIcon = withIcon(faArrowLeft);

interface BreadcrumbItem {
    label: string;
    to?: string;
}

interface IntegrationBreadcrumbProps {
    items: BreadcrumbItem[];
    backTooltip: string;
}

const linkClassName =
    'flex flex-shrink min-w-0 gap-3 rounded transition-colors hover:bg-surface-strong py-1 px-2 -mx-2 items-center cursor-pointer select-text font-semibold text-base text-content-medium hover:text-content-strong';

const IntegrationBreadcrumb = ({ items, backTooltip }: IntegrationBreadcrumbProps) => {
    const backTo = [...items].reverse().find((item) => item.to)?.to;

    return (
        <div className="flex items-center">
            {backTo && (
                <Link className={`${linkClassName} text-content-strong mr-1`} to={backTo}>
                    <Tooltip content={backTooltip}>
                        <BackIcon />
                    </Tooltip>
                </Link>
            )}
            {items.map((item, index) => (
                <div key={index} className="flex items-center">
                    {index > 0 && <Page.HeaderSeparator />}
                    {item.to ? (
                        <Link className={linkClassName} to={item.to}>
                            {item.label}
                        </Link>
                    ) : (
                        <span className="font-semibold text-base text-content-strong">{item.label}</span>
                    )}
                </div>
            ))}
        </div>
    );
};

export default IntegrationBreadcrumb;
